var NKTEN_DISABLE_ANIMATIONS = true;

document.addEventListener('DOMContentLoaded', initTrustBarNkten);
if (window.Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', initTrustBarNkten);
}

function initTrustBarNkten(event) {
  const root = event && event.target && event.target.querySelector
    ? event.target.querySelector('[data-trust-bar-nkten]')
    : document.querySelector('[data-trust-bar-nkten]');

  const sections = root ? [root] : document.querySelectorAll('[data-trust-bar-nkten]');

  sections.forEach((section) => {
    if (!section || section.dataset.trustBarInitialized) return;
    section.dataset.trustBarInitialized = 'true';

    const numbers = section.querySelectorAll('[data-trust-number]');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    numbers.forEach((el) => {
      const target = parseInt(el.dataset.target, 10) || 0;
      const suffix = el.dataset.suffix || '';

      if (NKTEN_DISABLE_ANIMATIONS || prefersReducedMotion || !window.gsap) {
        el.textContent = target.toLocaleString() + suffix;
        return;
      }

      const counter = { value: 0 };

      const runCount = () => {
        gsap.to(counter, {
          value: target,
          duration: 1.6,
          ease: 'expo.out',
          onUpdate: () => {
            el.textContent = Math.round(counter.value).toLocaleString() + suffix;
          },
        });
      };

      if (window.ScrollTrigger) {
        gsap.registerPlugin(ScrollTrigger);
        ScrollTrigger.create({
          trigger: el,
          start: 'top 85%',
          once: true,
          onEnter: runCount,
        });
      } else {
        runCount();
      }
    });
  });
}
